module.exports = __webpack_public_path__ + "img/close.472952fa.svg";